<template>
    <div class="view">
        <!-- Header -->
        <div class="page-top text-center text-md-left">
            <div class="container h-100">
                <div class="row h-100 d-flex align-items-center justify-content-between">
                    <div class="col-md-5 mt-5 pt-5 mt-md-0">
                        <h2 class="h1-responsive mb-4">{{ msg.header.title }}</h2>
                        <p>{{ msg.header.text }}</p>
                    </div>
                    <div class="col-md-6">
                        <div class="pill-1 pink darken-1"></div>
                        <img src="../assets/svg/house.svg" class="w-75 pt-0 pt-md-2 mx-auto" alt="Image">
                    </div>
                </div>
            </div>
        </div>

        <hr class="container d-none d-md-block">

        <!-- Information -->
        <div style="z-index: 2 !important; background-color: white;">
            <div class="container my-5 py-5">
                <div class="row d-flex justify-content-between">
                    <div class="col-md-5 mb-md-0 mb-5">
                        <img src="../assets/svg/thinking-1.svg" class="w-100 pt-3 pb-2" alt="Icon">
                        <div class="row d-flex justify-content-between align-items-center my-3">
                            <div class="col-md-5">
                                <h4 class="h4-responsive mb-0">{{ msg.form.email }}</h4>
                            </div>
                            <div class="col-md-7 text-right">
                                <p class="mb-0">me@arttupesonen.fi</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mb-md-0 mb-5">
                        <form @submit.prevent="submit()">
                            <input type="text" class="form-control mb-4" title="name" v-model="name" :placeholder="msg.form.name + ' *'" max="255" required>
                            <input type="email" class="form-control mb-4" title="email" v-model="email" :placeholder="msg.form.email + ' *'" max="255" required>
                            <input type="tel" class="form-control mb-4" title="phone" v-model="phone" :placeholder="msg.form.phone" max="20">
                            <textarea class="form-control mb-4" title="phone" v-model="message" :placeholder="msg.form.message + ' *'" rows="5" max="5000" required></textarea>
                            <p>{{ feedback }}</p>
                            <button class="btn btn-pink btn-rounded" :class="{disabled : btnDisabled}" type="submit">{{ msg.form.button }}</button>
                        </form>
                    </div>
                </div>
            </div>

            <hr class="container">

            <!-- Team -->
            <div class="container my-5 py-5">
                <h2 class="h2-responsive text-center mb-5">{{ msg.team.title }}</h2>
                <div class="row d-flex justify-content-center">
                    <div class="col-md-4 mb-4 mb-md-0">
                        <div class="card border">
                            <div class="card-body text-center py-5">
                                <i class="fas fa-user fa-3x orange-text"></i>
                                <h3 class="h3-responsive font-weight-normal my-3">Arttu Pesonen</h3>
                                <p></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mb-4 mb-md-0">
                        <div class="card border">
                            <div class="card-body text-center py-5">
                                <i class="fas fa-user fa-3x orange-text"></i>
                                <h3 class="h3-responsive font-weight-normal my-3">Veeti Lassila</h3>
                                <p></p>
                            </div>
                        </div>	
                    </div>	
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { lang } from './../language';
    import axios from 'axios';

    export default {
        name: 'Contact',
        data() {
            return {
                name: "",
                email: "",
                phone: "",
                message: "",
                feedback: "",
                btnDisabled: false,
                msg: null,
            }
        },
        created() {
            this.msg = lang.contact_page;
        },
        methods: {
            submit() {
                axios.post('https://api.verkkolabra.com/contact', {
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    message: this.message
                }).then(response => {
                    if (response.status == 200)
                        this.feedback = lang.contact_page.form.feedback_success;
                        this.btnDisabled = true;
                }).catch(error => {
                    this.feedback = lang.contact_page.form.feedback_error;
                });
            }
        },
    }
</script>

<style scoped>
    .page-top {
        height: 60vh;
    }

    .pill-1 {
        content: "";
        position: absolute;
        height: 760px;
        width: 1450px;
        border-radius: 780px;
        z-index: -100;
        -webkit-transform: rotate(-60deg);
        transform: rotate(-60deg);
        right: -800px;
        top: -620px;
    }
</style>